var _circle, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStronglyAgree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 37,
    fill: "white",
    stroke: "#136A0B",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#136A0B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 28,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#136A0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 49C35.102 68.72 50.297 60.7967 56 49H24Z",
    fill: "#136A0B",
    stroke: "#136A0B",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStronglyAgree);
export default __webpack_public_path__ + "static/media/strongly_agree.6e47b42b89a226358b90f49d93354ea8.svg";
export { ForwardRef as ReactComponent };